<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <button
        class="ch-floating-btn ch-menu-btn"
        @click="openDialog"
      >
        <span><i class="far fa-plus-square fa-fw"></i></span>
        USER
      </button>
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <!-- <button @click.stop="toogleDrawer" class="ch-menu-btn ch-navigation-toogle" type="button">
            <span class="ch-menu-btn-icon" v-show="navigationDrawer">
              <i class="fas fa-minus fa-fw"></i>
            </span>
            <span class="ch-menu-btn-icon" v-show="!navigationDrawer">
              <i class="fas fa-plus fa-fw"></i>
            </span>
          </button> -->
          <span class="ch-component-title pl-2">USER</span>
        </div>
        <div class="filter-body-wrapper">
          <users-filter :storeFilter="storeFilter"></users-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <users-list :storeFilter="storeFilter" :storePage="storePage"></users-list>
      </v-container>
      <create-User></create-User>
      <scroll-event></scroll-event>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { usersEventBus } from '@/components/admin/users/usersEventBus';
  import UsersFilter from '@/components/admin/users/UsersFilter';
  import UsersList from '@/components/admin/users/UsersList';
  import CreateUser from '@/components/admin/users/CreateUser';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        usersEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      UsersFilter, UsersList, CreateUser, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Users.vue